// export const apiUrl = 'http://localhost:8000' 
export const apiUrl = 'https://api.tengahtengah.com/'